
























































































































import {Component, Vue} from 'vue-property-decorator';
import {store} from '@/_store';
import {ACCOUNT_ACTION, IAccountState} from "@/_store/account";
import {mapState} from "vuex";
import Confirm from "@/components/Confirm.vue";
import {Role} from "@/_objects/IUser";
import {SNACK_ACTION} from "@/_store/snackbar";

@Component({
    components: {Confirm},
    computed: mapState('account', {
        account: (state: IAccountState) => state,
    }),
})
export default class Secure extends Vue {
    public account!: IAccountState;
    private dialog: boolean = false;
    private drawer = null;

    private nav = [
        // { icon: 'dashboard', text: 'Dashboard', route: "/secure/dashboard", access: [] },
        { icon: 'photo_library', text: 'Media Library', route: "/secure/media", access: [] },
        { icon: 'people', text: 'Manage Users', route: "/secure/users", access: [Role.ADMIN] },
        // { icon: 'content_copy', text: 'Duplicates' },
        // {
        //     icon: 'keyboard_arrow_up',
        //     'icon-alt': 'keyboard_arrow_down',
        //     text: 'Labels',
        //     model: true,
        //     children: [
        //         { icon: 'add', text: 'Create label' }
        //     ]
        // },
        { icon: 'power_settings_new', text: 'Log Off', exec: () => {
                this.showLogOffDialog();
            }, access: [] },
    ];

    private showLogOffDialog() {
        this.dialog = true;
    }

    private checkAccess(roles: Role[]) {
        if (this.account && this.account.user && this.account.user.role) {
            return roles.length === 0 || roles.indexOf(this.account.user.role) > -1;
        }

        return roles.length === 0;

    }

    private async onConfirmLogoff() {
        store.dispatch(ACCOUNT_ACTION.LOGOFF);
    }

  get env() {
    return this.$store.getters["api/env"];
  }

}
